import _ from 'lodash'
import PeriodicityService from '../../catalogs/services/periodicityService'
import ReminderService from '../services/reminderService'

export default {
  namespaced: true,
  state: () => ({
    periodicities: [],
    periodicityDefault: null,
    messageNotification:
      'Enviaremos @ recordatorios automáticos a los involucrados que no hayan firmado el documento.',
    messageNotificationCancelledSigned:
      'Los recordatorios ya no están disponibles.',
    titleReminder: 'Recordatorio Genérico'
  }),
  mutations: {
    SET_PERIODICITIES(state, periodicities) {
      state.periodicities = periodicities
    },
    SET_PERIODICITY_DEFAULT(state, item) {
      state.periodicityDefault = item
    }
  },
  actions: {
    async getPeriodicities({ commit }) {
      const service = new PeriodicityService()

      const { data } = await service.getPeriodicities()
      const resp = data.data

      if (resp.length > 0) {
        commit('SET_PERIODICITIES', resp)
        const def = _.find(resp, ['default', true])
        commit('SET_PERIODICITY_DEFAULT', def)
      }
    },
    async createReminders({ state }, documents) {
      const service = new ReminderService()

      Promise.all(
        [].map.call(documents, function(document) {
          return service.createReminder({
            idDocumento: document.presignUrl.fields['x-amz-meta-DocumentId'],
            nombre: state.titleReminder,
            periodicidad: state.periodicityDefault.id,
            recordarFirmantes: true,
            recordarPropietario: true,
            mensaje: ''
          })
        })
      )
        .then(function(results) {
          return results
        })
        .then(resultList => {
          return resultList
        })
    }
  },
  getters: {
    periodicities(state) {
      return state.periodicities
    },
    periodicityDefault(state) {
      return state.periodicityDefault
    },
    messageNotification(state) {
      const period =
        state.periodicityDefault != null
          ? state.periodicityDefault.descripcion.toLowerCase()
          : ''
      return state.messageNotification.replace('@', period)
    },
    messageNotificationCancelledSigned(state)
    {
      return state.messageNotificationCancelledSigned
    }
  }
}
